document.addEventListener('DOMContentLoaded', function () {
  var boton = document.getElementById('add-to-cart-btn');
  if (!boton) return; // páginas sin botón de compra (inicio, colecciones, etc.)

  var formulario = boton.closest('form') || (boton.closest('.m-product-form--wrapper') && boton.closest('.m-product-form--wrapper').querySelector('form'));

  // Aviso que indica qué falta elegir, como una tarjeta visible (no un texto suelto)
  var contenedor = boton.closest('.m-product-form--wrapper') || boton.parentElement;
  var aviso = document.createElement('div');
  aviso.id = 'atc-hint';
  aviso.className = 'mm-atc-aviso';
  aviso.setAttribute('role', 'status');
  aviso.setAttribute('aria-live', 'polite');
  aviso.innerHTML = '<span class="mm-atc-aviso__icono" aria-hidden="true">!</span><span class="mm-atc-aviso__texto"></span>';
  contenedor.parentNode.insertBefore(aviso, contenedor);
  var avisoTexto = aviso.querySelector('.mm-atc-aviso__texto');

  function $(selector) { return document.querySelector(selector); }

  function asignarOculto(id, valor) {
    var el = document.getElementById(id);
    if (el) el.value = (valor || '').trim();
  }

  function unir(lista) {
    if (lista.length <= 1) return lista.join('');
    return lista.slice(0, -1).join(', ') + ' y ' + lista[lista.length - 1];
  }

  // UX 06 (13-oct-2026): "De parte de" ya no bloquea "Añadir al carrito".
  // Si el cliente no lo completa aquí, se le pide en el carrito antes de "Finalizar compra" (mm-carrito-envia.js).
  function faltantes() {
    var faltan = [];
    var base = $('select[name="properties[Base]"]');
    var fecha = $('input[name="properties[Fecha]"]');
    var horario = $('select[name="properties[Horario]"]');
    var hayDiseno = document.querySelectorAll('input[name="properties[Dedicatoria]"]').length > 0;
    var diseno = $('input[name="properties[Dedicatoria]"]:checked');

    if (base && !base.value) faltan.push('base');
    if (fecha && !fecha.value) faltan.push('fecha');
    if (horario && !horario.value) faltan.push('horario');
    if (hayDiseno && !diseno) faltan.push('tarjeta');
    return faltan;
  }

  var ETIQUETAS = {
    base: 'el tipo de base',
    fecha: 'el día de entrega',
    horario: 'el horario de entrega',
    tarjeta: 'el diseño de tu tarjeta',
    envia: 'de parte de quién es el arreglo'
  };

  // Elemento al que hay que llevar la vista y resaltar por cada campo pendiente
  function elementoDe(tipo) {
    var el = null;
    if (tipo === 'base') el = $('select[name="properties[Base]"]');
    if (tipo === 'fecha') el = $('input[name="properties[Fecha]"]');
    if (tipo === 'horario') el = $('select[name="properties[Horario]"]');
    if (tipo === 'tarjeta') el = document.querySelector('.dedicatorias-list') || document.querySelector('input[name="properties[Dedicatoria]"]');
    if (tipo === 'envia') el = document.getElementById('de-parte-de');
    if (!el) return null;
    return el.closest('.custom-container') || el.closest('.departe-container') || el;
  }

  function mensajeFaltante(faltan) {
    if (faltan.length === 1) {
      var verbo = faltan[0] === 'envia' ? 'Indica ' : 'Elige ';
      return verbo + ETIQUETAS[faltan[0]] + ' para continuar';
    }
    return 'Completa ' + unir(faltan.map(function (k) { return ETIQUETAS[k]; })) + ' para continuar';
  }

  // UX 01: el aviso solo aparece después de que el cliente intenta añadir al carrito
  var intentoCompra = false;
  function verificarCondiciones(mostrar) {
    if (mostrar) intentoCompra = true;
    var faltan = faltantes();
    var ver = intentoCompra && faltan.length > 0;
    avisoTexto.textContent = ver ? mensajeFaltante(faltan) : '';
    aviso.classList.toggle('is-visible', ver);
    return faltan;
  }

  var resaltadoActivo = null;
  function resaltar(tipo) {
    var el = elementoDe(tipo);
    if (!el) return;
    if (resaltadoActivo && resaltadoActivo !== el) resaltadoActivo.classList.remove('mm-campo-falta');
    el.classList.remove('mm-campo-falta');
    void el.offsetWidth; // reinicia la animación aunque sea el mismo campo
    el.classList.add('mm-campo-falta');
    resaltadoActivo = el;
    if (el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { el.classList.remove('mm-campo-falta'); }, 2200);
  }

  // Al tocar "Añadir al carrito": si falta algo, no envía el formulario y lleva la vista al primer campo pendiente
  if (formulario) {
    formulario.addEventListener('submit', function (e) {
      var faltan = verificarCondiciones(true);
      if (faltan.length) {
        e.preventDefault();
        e.stopImmediatePropagation();
        resaltar(faltan[0]);
      }
    }, true);
  }

  // Tipo de base
  var base = $('select[name="properties[Base]"]');
  if (base) {
    base.addEventListener('change', function () {
      asignarOculto('base_seleccionada', this.value);
      verificarCondiciones();
    });
  }

  // Horario
  var horario = $('select[name="properties[Horario]"]');
  if (horario) {
    horario.addEventListener('change', function () {
      asignarOculto('horario_seleccionado', this.value);
      verificarCondiciones();
    });
  }

  // Fecha
  var fecha = $('input[name="properties[Fecha]"]');
  if (fecha) {
    ['input', 'change'].forEach(function (evento) {
      fecha.addEventListener(evento, function () {
        asignarOculto('fecha_seleccionada', this.value);
        verificarCondiciones();
      });
    });
  }

  // Imagen de la tarjeta elegida: propiedad oculta (se ve en el pedido, el cliente no la ve)
  var referenciaTarjeta = document.getElementById('diseno_dedicatoria_seleccionado');
  var ocultoImagen = document.getElementById('tarjeta_imagen');
  if (!ocultoImagen && referenciaTarjeta && referenciaTarjeta.parentNode) {
    ocultoImagen = document.createElement('input');
    ocultoImagen.type = 'hidden';
    ocultoImagen.name = 'properties[_Imagen de tarjeta]';
    ocultoImagen.id = 'tarjeta_imagen';
    ocultoImagen.value = '';
    referenciaTarjeta.parentNode.insertBefore(ocultoImagen, referenciaTarjeta.nextSibling);
  }
  function urlImagen(radio) {
    var u = (radio && radio.getAttribute('data-imagen')) || '';
    return u.indexOf('//') === 0 ? 'https:' + u : u;
  }

  // Diseño de dedicatoria
  document.querySelectorAll('input[name="properties[Dedicatoria]"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      asignarOculto('diseno_dedicatoria_seleccionado', this.value);
      asignarOculto('tarjeta_imagen', urlImagen(this));
      verificarCondiciones();
    });
  });

  // De parte de: propiedad oculta dentro del formulario de compra
  var deParte = document.getElementById('de-parte-de');
  if (deParte) {
    var ocultoDeParte = document.getElementById('de_parte_de');
    var referencia = document.getElementById('nombre_fallecido');
    if (!ocultoDeParte && referencia && referencia.parentNode) {
      ocultoDeParte = document.createElement('input');
      ocultoDeParte.type = 'hidden';
      ocultoDeParte.name = 'properties[De parte de]';
      ocultoDeParte.id = 'de_parte_de';
      ocultoDeParte.value = '';
      referencia.parentNode.insertBefore(ocultoDeParte, referencia);
    }
    ['input', 'change'].forEach(function (evento) {
      deParte.addEventListener(evento, function () {
        asignarOculto('de_parte_de', this.value);
        verificarCondiciones();
      });
    });
    asignarOculto('de_parte_de', deParte.value);
  }

  // Estado inicial: el botón queda activo (reacciona siempre al toque); el aviso se muestra si falta algo
  verificarCondiciones();
});
